// Copyright (c) 2016 Deere & Company

import IntlMessageFormat from 'intl-messageformat';
import {getMessages} from '@deere/cps-it.warranty-i18n';
import {getStore} from '../../store-factory';

export const translate = (messageId, args = {}, primaryLanguageKey) => {

    const locale = primaryLanguageKey ?
        primaryLanguageKey :
        getStore().getState().user.details.settings.language.primaryLanguage.key;

    const messageToTranslate = getMessages()[locale][messageId] ?
        getMessages()[locale][messageId] :
        messageId;

    const message = new IntlMessageFormat(messageToTranslate, locale);

    return message.format(args);

};



// WEBPACK FOOTER //
// ./src/shared/services/translation-service.js